var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Solicitud Anulacion Ventas" },
          on: { cerrar: _vm.closeModal }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c("div", {
                staticClass: "boton_crear",
                staticStyle: { height: "37px" }
              })
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c("h3", [
                                _vm._v(
                                  "\n                Detalle SAV\n              "
                                )
                              ]),
                              _c(
                                "v-toolbar",
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      attrs: { centered: "" },
                                      model: {
                                        value: _vm.tabs,
                                        callback: function($$v) {
                                          _vm.tabs = $$v
                                        },
                                        expression: "tabs"
                                      }
                                    },
                                    [
                                      _c("v-tabs-slider", {
                                        attrs: { color: "yellow" }
                                      }),
                                      _c("v-tab", [_vm._v("Cabecera")]),
                                      _c("v-tab", [_vm._v("Dispositivos")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tabs-items",
                                {
                                  model: {
                                    value: _vm.tabs,
                                    callback: function($$v) {
                                      _vm.tabs = $$v
                                    },
                                    expression: "tabs"
                                  }
                                },
                                [
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2"
                                          },
                                          [
                                            _c(
                                              "FormFieldsContainer",
                                              {
                                                attrs: {
                                                  titulo:
                                                    "Solicitud Anulacion Venta"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "assignment",
                                                        color: "primary",
                                                        label: "Nombre SAV",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_nombre_SAV,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_nombre_SAV = $$v
                                                        },
                                                        expression:
                                                          "model_nombre_SAV"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "calendar_month",
                                                        color: "primary",
                                                        label:
                                                          "Fecha de Creación",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_fecha_creacion,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_fecha_creacion = $$v
                                                        },
                                                        expression:
                                                          "model_fecha_creacion"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "calendar_month",
                                                        color: "primary",
                                                        label:
                                                          "Fecha de Registro",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_fecha_registro,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_fecha_registro = $$v
                                                        },
                                                        expression:
                                                          "model_fecha_registro"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "text_snippet",
                                                        color: "primary",
                                                        label:
                                                          "Nombre de Nota de Venta",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_nombre_nota_venta,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_nombre_nota_venta = $$v
                                                        },
                                                        expression:
                                                          "model_nombre_nota_venta"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "description",
                                                        color: "primary",
                                                        label:
                                                          "Nombre de Factura",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_nombre_factura,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_nombre_factura = $$v
                                                        },
                                                        expression:
                                                          "model_nombre_factura"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "copyright",
                                                        color: "primary",
                                                        label: "Propietario",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_propietario,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_propietario = $$v
                                                        },
                                                        expression:
                                                          "model_propietario"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon": "badge",
                                                        color: "primary",
                                                        label:
                                                          "RUT del Cliente",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_rut_cliente,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_rut_cliente = $$v
                                                        },
                                                        expression:
                                                          "model_rut_cliente"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon": "store",
                                                        color: "primary",
                                                        label: "Razón Social",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_razon_social,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_razon_social = $$v
                                                        },
                                                        expression:
                                                          "model_razon_social"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon": "block",
                                                        color: "primary",
                                                        label:
                                                          "Tipo de Anulación",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_tipo_anulacion,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_tipo_anulacion = $$v
                                                        },
                                                        expression:
                                                          "model_tipo_anulacion"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "newspaper",
                                                        color: "primary",
                                                        label:
                                                          "Motivo de Anulación",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_motivo_anulacion,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_motivo_anulacion = $$v
                                                        },
                                                        expression:
                                                          "model_motivo_anulacion"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "category",
                                                        color: "primary",
                                                        label:
                                                          "Número de Equipos",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_numero_equipos,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_numero_equipos = $$v
                                                        },
                                                        expression:
                                                          "model_numero_equipos"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "payments",
                                                        color: "primary",
                                                        label: "Monto",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value: _vm.model_monto,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_monto = $$v
                                                        },
                                                        expression:
                                                          "model_monto"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "timeline",
                                                        color: "primary",
                                                        label: "Estado CRM",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value: _vm.model_estado,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_estado = $$v
                                                        },
                                                        expression:
                                                          "model_estado"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "timeline",
                                                        color: "primary",
                                                        label:
                                                          "Razón Estado CRM",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_razon_estado,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_razon_estado = $$v
                                                        },
                                                        expression:
                                                          "model_razon_estado"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { sm3: "", md3: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "move_up",
                                                        color: "primary",
                                                        label:
                                                          "Número de Movimiento",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_numero_movimiento,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_numero_movimiento = $$v
                                                        },
                                                        expression:
                                                          "model_numero_movimiento"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      sm12: "",
                                                      md12: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-textarea", {
                                                      attrs: {
                                                        "prepend-icon":
                                                          "edit_note",
                                                        color: "primary",
                                                        label: "Observaciones",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model_observaciones,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.model_observaciones = $$v
                                                        },
                                                        expression:
                                                          "model_observaciones"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "gridcard rounded-card"
                                              },
                                              [
                                                _c("MantenedorGridSinCodigo", {
                                                  attrs: {
                                                    "grid-options":
                                                      _vm.gridOptions,
                                                    "funcionalidad-id":
                                                      _vm.funcionalidad
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }